import MentionEditorContainer from './containers/MentionEditorContainer'

export default MentionEditorContainer
